import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { WhiteBlock } from '~/shared/ui/Wrappers'

export const Wrapper = styled(WhiteBlock)`
  box-shadow: none;
`

export const SubTitle = styled.div`
  color: ${myPalette.dark.main};
  font-size: 12px;
  margin-bottom: 4px;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const MainTaxiparkCmsLink = styled.a`
  font-size: 12px;
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 4px;
  font-weight: 700;
`

export const Title = styled.div`
  color: ${myPalette.midnightBlue.main};
  font-size: 16px;
  font-weight: 500;
  position: relative;
  width: 100%;
`
